import { EndpointKey } from '../http/EndpointKey';
import { HttpStatus } from '../store/http-responses/types';
var ConnectionCreateErrorCategory;

(function (ConnectionCreateErrorCategory) {
  ConnectionCreateErrorCategory["ObjectAlreadyExsists"] = "OBJECT_ALREADY_EXISTS";
  ConnectionCreateErrorCategory["MissingPermissions"] = "MISSING_PERMISSIONS";
  ConnectionCreateErrorCategory["Default"] = "DEFAULT";
})(ConnectionCreateErrorCategory || (ConnectionCreateErrorCategory = {}));

export let GoogleSyncAlertValue;

(function (GoogleSyncAlertValue) {
  GoogleSyncAlertValue["warning"] = "warning";
  GoogleSyncAlertValue["success"] = "success";
})(GoogleSyncAlertValue || (GoogleSyncAlertValue = {}));

export let GoogleSyncErrorStatus;

(function (GoogleSyncErrorStatus) {
  GoogleSyncErrorStatus["Loading"] = "loading";
  GoogleSyncErrorStatus["Completed"] = "completed";
  GoogleSyncErrorStatus["Failed"] = "failed";
})(GoogleSyncErrorStatus || (GoogleSyncErrorStatus = {}));

export const SignupInteractionByEndpointKey = {
  [EndpointKey.GoogleContactsCreateConnection]: 'google-data-sync-creation-connection-error',
  [EndpointKey.GoogleContactsSaveConnection]: 'google-data-sync-save-connection-error',
  [EndpointKey.GoogleContactsActivateSync]: 'google-data-sync-active-sync-error'
};
export const GoogleSyncErrorStatusByHttpStatus = {
  [HttpStatus.Fetching]: GoogleSyncErrorStatus.Loading,
  [HttpStatus.Error]: GoogleSyncErrorStatus.Failed,
  [HttpStatus.Success]: GoogleSyncErrorStatus.Completed
};